import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

interface HoverTooltipProps {
  title: string;
  isVisible: boolean;
  triggerRef: React.RefObject<HTMLElement | null>;
}

const HoverTooltip: React.FC<HoverTooltipProps> = ({
  title,
  isVisible,
  triggerRef,
}) => {
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (isVisible && triggerRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const spacing = 8; // Space between trigger and tooltip

      setTooltipPosition({
        top: triggerRect.top - spacing,
        left: triggerRect.left + triggerRect.width / 2,
      });
    }
  }, [isVisible, triggerRef]);

  if (!isVisible || !title) return null;

  return createPortal(
    <div
      className="fixed z-99999 pointer-events-none transform -translate-x-1/2 -translate-y-full"
      style={{
        top: `${tooltipPosition.top}px`,
        left: `${tooltipPosition.left}px`,
      }}
    >
      <div
        className="relative text-white text-sm px-2 py-1 rounded shadow-lg max-w-xs wrap-break-word whitespace-pre-line"
        style={{ backgroundColor: 'rgba(97, 97, 97, 0.92)' }}
      >
        {title}
        {/* Arrow pointing down to the trigger */}
        <div
          className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent"
          style={{ borderTopColor: 'rgba(97, 97, 97, 0.92)' }}
        ></div>
      </div>
    </div>,
    document.body
  );
};

export default HoverTooltip;
